import usePageTitle from '@src/hooks/usePageTitle';

// for class components
function PageTitle({ text }) {
  usePageTitle({ text });
  return null;
}

export default PageTitle;
